// API Base URL - Your Hostinger domain
// This points to the /api folder in public_html
const API_BASE_URL = 'https://inspectiq.in/api';

export default API_BASE_URL;
